<template lang="html">
<transition name="splash">
  <div class="TheSplash" :class="{'with-leave-transition': showLeaveTransition}">
    <article v-if="splashIsVisible">
      <div class="overlay-dark">
        <div
          class="card light-background card-with-dark-background"
          :class="{
            'ready': ready,
            'with-release-notes': showReleaseNotes
          }"
        >
          <div class="content columns">
            <header class="header col-1">
                <Logo level="h1"/>
                <dfn class="subtitle">
                  <p><span class="line">a fullscreen </span><span class="line">countdown timer </span><span class="line">for workshops, </span><span class="line">meetings and </span><span class="line">presentations</span></p>
                </dfn>
                <div
                  v-if="showReleaseNotes && releaseNotes.version"
                  class="h3 version-number"
                  :class='{"version-number--long": releaseNotes.version.length > 3}'
                >
                  V {{releaseNotes.version}}
                </div>
            </header>
            <div class="col-2">
              <div class="col-2-inside">
                <div v-if="!showReleaseNotes">
                  <div v-if="headingWithDuration">
                    <h2 class="h1 heading-duration">{{headingWithDuration}}</h2>
                  </div>
                  <div class="usps">
                    <div class="usp">
                      <h3 class="h3">Fast & easy</h3>
                      <p class="p">Use the on-screen buttons or the keyboard shortcuts.</p>
                    </div>
                    <div class="usp">
                      <h3 class="h3">Reliable & accurate</h3>
                      <p class="p">You could set a timer, restart your computer and come back here to find it still counting down. </p>
                    </div>
                    <div class="usp">
                      <h3 class="h3">Pay what you want</h3>
                      <p class="p">No ads—no interruptions but the gong at 0:00. If you find Big Timer useful, you decide how much you pay for it.</p>
                    </div>
                  </div>
                  <div class="cookies-info">
                    <p class="p">Big Timer uses cookies for functionality and analytics. No personal information is collected.</p>
                  </div>
                  <div
                    class="cookies-cta"
                    ref="cookies-cta"
                  >
                    <button
                      ref="acceptCookies"
                      class="button primary-dark with-label"
                      @click="onAcceptCookies">Continue</button>
                  </div>
                </div>
                <div class="welcome-back" v-if="showReleaseNotes">
                  <p class="new">{{releaseNotes.date}}</p>
                  <h2 class="h2">{{releaseNotes.title}}</h2>
                  <p v-html="releaseNotes.body" />
                  <div class="release-notes-cta">
                    <button
                      ref="closeReleaseNotes"
                      class="button primary-dark with-label"
                      @click="onCloseReleaseNotes">Continue</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <KeyboardShortcuts
      @onTabPress="handleTabPress"
      @onEscapePress="handleEscapePress" />
  </div>
</transition>
</template>

<script>
// Data
import ReleaseNotesJSON from "../assets/data/ReleaseNotes";

// Components
import KeyboardShortcuts from "./KeyboardShortcuts";
import Logo from "./Logo";

export default {
  name: "TheSplash",

  components: {
    Logo,
    KeyboardShortcuts,
    ReleaseNotesJSON,
  },

  data() {
    return {
      ready: false,
      releaseNotes: ReleaseNotesJSON[0],
      splashIsVisible: false, // Prevents the modal getting shown briefly on loading
      showReleaseNotes: false,
      releaseDate: ReleaseNotesJSON[0].release,
      announceRelease: ReleaseNotesJSON[0].announce,
      headingWithDuration: "",
      localStorageKeyCookies: "cookiesAccepted",
      localStorageKeyUsedVersion: "usedVersion",
      showLeaveTransition: false,
    };
  },

  mounted() {
    // this.initialize();

    // CLOSE THE WELCOME OR RELEASE NOTE MODAL ON HOME PAGE 
    this.$emit("close");
  },

  methods: {
    initialize() {
      // Check if cookies were accepted
      // Consider that local storage only contains strings when checking values.
      const lastUsedDate = Number(
        localStorage.getItem(this.localStorageKeyUsedVersion)
      );

      if (!lastUsedDate) {
        this.createTextBasedOnURLQuery();
        this.splashIsVisible = true;
        this.showLeaveTransition = true;
        this.unhideContent();
      } else {
        localStorage.setItem(this.localStorageKeyUsedVersion, this.releaseDate);

        if (this.announceRelease && lastUsedDate < this.releaseDate) {
          this.showTheReleaseNotes();
        } else {
          this.$emit("close");
        }
      }
    },

    unhideContent() {
      setTimeout(() => {
        this.ready = true;
      }, 300);
    },

    createTextBasedOnURLQuery() {
      let queryHours = parseInt(this.$route.query.hours, 10);
      let queryMinutes = parseInt(this.$route.query.minutes, 10);
      let querySeconds = parseInt(this.$route.query.seconds, 10);

      // Make sure the variables are numbers that can be valided
      if (!queryHours) queryHours = 0;
      if (!queryMinutes) queryMinutes = 0;
      if (!querySeconds) querySeconds = 0;

      // If set duration is less than 1 minute
      if (querySeconds && queryMinutes === 0 && queryHours === 0) {
        this.headingWithDuration = querySeconds + " Second countdown";
      }
      // If set duration is in whole minutes
      else if (queryMinutes && querySeconds === 0 && queryHours === 0) {
        this.headingWithDuration = queryMinutes + " Minute countdown";
      }
      // If set duration is in whole hours
      else if (queryHours && queryMinutes === 0 && querySeconds === 0) {
        this.headingWithDuration = queryHours + " Hour countdown";
      }
    },

    showTheReleaseNotes() {
      this.showReleaseNotes = true;
      this.splashIsVisible = true;
      this.showLeaveTransition = true;
      this.unhideContent();

      _paq.push(["trackEvent", "Showing release notes", this.releaseDate]);
    },

    handleTabPress(e) {
      e.preventDefault();
      if (this.showReleaseNotes) {
        this.$refs.closeReleaseNotes.focus();
      } else {
        this.$refs.acceptCookies.focus();
      }
    },

    handleEscapePress() {
      this.$refs.cookies - cta.focus();
    },

    // When user accepts the cookies
    onAcceptCookies() {
      localStorage.setItem(this.localStorageKeyCookies, this.today);
      localStorage.setItem(this.localStorageKeyUsedVersion, this.releaseDate);
      this.$emit("close");
    },
    // When user closes welcome screen for returning users
    onCloseReleaseNotes() {
      this.$emit("close");
    },
  },
  computed: {
    today() {
      const date = new Date();
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let day = date.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      const today = "" + year + month + day;
      return today;
    },
  },
};
</script>

<style lang="scss">
@import "../style/abstracts/functions.scss";
@import "../style/abstracts/mixins.scss";
@import "../style/abstracts/variables.scss";

// Variables and mixins
///////////////////////

$break-2-cols: 450;
$break-fixed-width: 1000;
$border-width: 0.4;

@mixin svg-border-basics {
  // SVG-based dotted border. The border-width is set further below to actually make the border appear in a responsive way.
  border-color: $color-very-dark; // Safari & Chrome need border-style and border-color
  border-image-source: url("../assets/images/styling/border-decoration.svg");
  border-image-repeat: round;
  border-image-outset: 0.2rem; // center the dots on the border
}

// Word mark and sub title
@mixin flex-content($factor) {
  .logo-line-1 {
    margin-left: -3 * $factor + vw;
    font-size: 45.5 * $factor + vw;
  }
  .logo-line-2 {
    margin-top: 6 * $factor + vw;
    margin-left: -0.4 * $factor + vw;
    font-size: 27.8 * $factor + vw;
  }
  .subtitle {
    margin-top: 8 * $factor + vw;

    .line {
      // Avoid line breaks
      margin-right: -2 * $factor + vw;

      &:nth-child(1) {
        margin-top: 0.5 * $factor + vw;
        font-size: 16.8 * $factor + vw;
      }
      &:nth-child(2) {
        font-size: 11.4 * $factor + vw;
      }
      &:nth-child(3) {
        margin-top: 0.5 * $factor + vw;
        font-size: 13.1 * $factor + vw;
      }
      &:nth-child(4) {
        font-size: 14.2 * $factor + vw;
      }
      &:nth-child(5) {
        font-size: 14.5 * $factor + vw;
      }
    }
  }
}

// Container for avoiding scrollbars during transition
// and to scope the CSS classes
//////////////////////////////////////////////////////

.TheSplash {
  position: absolute;
  top: 0;
  width: 100%;
  min-height: calc(var(--vh, 1vh) * 100);
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  .overlay-dark {
    display: flex;
    justify-content: center;
    position: absolute;
    top: 0;
    min-height: 100vh;
    align-items: center; // Vertically center
    position: absolute;
  }
  .card {
    margin-left: env(safe-area-inset-left);
    margin-right: env(safe-area-inset-right);
    margin-top: calc(2.5vw + env(safe-area-inset-top)); // iPhone X safe area;
    margin-bottom: 2.5vw;
    width: 95vw;
    min-width: 200px;
    max-width: 93rem;

    .no-touch-events & {
      margin-bottom: $large + rem;
    }
    .touch-events & {
      margin-bottom: 4 * $large + rem;
    }
  }

  // Content
  //////////
  .logo {
    font-size: 3.9vw;
    color: $color-dark;
  }

  .header {
    display: flex;
    flex-direction: column;
  }
  .subtitle {
    display: block;
    margin-top: 8vw;
    font-style: normal;
    white-space: nowrap;

    .with-release-notes & {
      display: none;
    }

    .line {
      line-height: 1;
      display: block;
    }
  }
  .heading-duration {
    font-size: 10vw;
    font-weight: normal;
    text-transform: uppercase;
  }
  .usps {
    padding-bottom: $large + rem;
  }
  .usp:nth-child(2n + 2) {
    text-align: right;
  }
  .usp:last-child {
    p:last-child {
      margin-bottom: 0;
    }
  }

  .cookies-info,
  .cookies-cta {
    margin-right: (-1 * $default) + rem;
    margin-left: (-1 * $default) + rem;
    padding-right: $default + rem;
    padding-left: $default + rem;
    background: $color-off-white;
  }
  .cookies-info {
    position: relative;
    padding-top: $large + rem;
    padding-bottom: $default + rem;

    &::after {
      @include svg-border-basics;
      content: "\00a0";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;

      border-style: solid;
      border-width: $border-width + rem 0 0 0;
      border-image-slice: 20% 10%; // Horizontal, vertical: https://developer.mozilla.org/en-US/docs/Web/CSS/border-image-slice
    }
    .p {
      margin-bottom: 0;
      font-size: 1.2rem;
      color: $color-dark-grey;
    }
  }
  .cookies-cta {
    margin-bottom: (-1 * $default) + rem;
    padding-bottom: $large + rem;
    text-align: center;
    border-radius: 0 0 $small + rem $small + rem; // Because Safari has an overflow: hidden; bug

    &:focus {
      outline: none;
    }
    .button.primary-dark {
      color: $color-primary;

      &:active {
        color: $color-primary-lit;
      }
    }
  }

  .welcome-back .h2,
  .welcome-back .h3 {
    margin-top: 0;
  }
  .version-number {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: $large + rem auto;
    width: 1.5 * $large + rem;
    height: 1.5 * $large + rem;
    padding-top: 0.1rem;
    color: $color-off-white;
    background: $color-dark;
    border-radius: 100%;
  }
  .version-number--long {
    width: 2 * $large + rem;
    height: 2 * $large + rem;
  }
  .new {
    margin-bottom: 0;
    text-transform: uppercase;
  }
  .release-notes-cta {
    text-align: center;
  }

  @media (max-width: $break-2-cols - 1 + px) {
    .header {
      @include flex-content(1);
    }
  }

  // Two-column layout
  ////////////////////

  // Remove added margin for iOS Safari bottom menu.
  @media screen and (min-width: $break-2-cols + px) and (min-height: 560px) {
    .card {
      margin-bottom: 2.5vw;

      .no-touch-events & {
        margin-bottom: 2.5vw;
      }
    }
  }
  @media screen and (min-width: $break-2-cols + px) and (max-width: $break-fixed-width - 1 + px) {
    .col-1 {
      @include flex-content(0.25);
    }
  }
  @media screen and (min-width: $break-2-cols + px) {
    .card {
      background: $color-off-white;
    }
    .columns {
      display: flex;
    }
    .col-1,
    .col-2 {
      margin-top: (-1 * $default) + rem;
      margin-bottom: (-1 * $default) + rem;
      padding-top: $default + rem;
      padding-bottom: $default + rem;
    }
    .col-1 {
      position: relative;
      margin-left: (-1 * $default) + rem;
      padding: 5.5vw;
      justify-content: center;
      background-color: $color-primary;
    }
    .col-2 {
      @include svg-border-basics;
      position: relative;
      flex-grow: 1;

      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-right: $default + rem;
      padding-left: $default - $border-width + rem;
      margin-right: (-1 * $default) + rem;

      background: $color-off-white;

      border-style: solid;
      border-width: 0 0 0 $border-width + rem;
      border-image-slice: 10% 20%; // Horizontal, vertical: https://developer.mozilla.org/en-US/docs/Web/CSS/border-image-slice

      overflow: hidden;

      @media screen and (min-height: 600px) {
        padding-top: 2 * $medium + rem;
        padding-bottom: 2 * $medium + rem;
      }
    }
    .logo {
      font-size: 1vw;
    }
    .version-number {
      margin-bottom: 0;
    }
    .col-2-inside {
      margin-left: auto;
      margin-right: auto;
      max-width: 48rem;
    }
    .heading-duration {
      font-size: 7vw;
    }
    .usps {
      display: flex;
      flex-direction: column;
      padding-bottom: 0;
    }
    .usp {
      &:nth-child(2) {
        align-self: flex-end;
        max-width: 35rem;
      }
      .h3,
      .p {
        color: $color-dark-grey;
      }
      .p {
        margin-bottom: 0;
      }
      @media screen and (min-width: 780px) {
        .p {
          margin-left: $default + rem;
        }
        &:nth-child(2) {
          .p {
            margin-left: 0;
            margin-right: $default + rem;
          }
        }
      }
    }
    .cookies-info {
      &::after {
        content: none;
      }
      .p {
        color: $color-dark-grey;
      }
    }
    .release-notes-cta {
      .button.primary-dark {
        color: $color-primary;

        &:active,
        .no-touch-events &:active,
        .no-touch-events &:active:focus {
          color: $color-primary-lit;
        }
      }
    }
  }

  // Fix logo size, put version number in the divider
  @media screen and (min-width: $break-fixed-width + px) {
    .logo {
      font-size: 1rem;
    }
    .subtitle {
      .with-release-notes & {
        display: block;
      }
    }
    .version-number {
      position: absolute;
      top: 13%;
      right: -0.75 * $large + rem;
      z-index: 1;
    }
    .version-number--long {
      right: -1 * $large + rem;
    }
    .col-1 {
      padding: 5.5rem;
    }
    .subtitle {
      margin-top: 2rem;

      .line {
        // Avoid line breaks
        margin-right: -0.5rem;

        &:nth-child(1) {
          margin-top: 0.125rem;
          font-size: 4.2rem;
        }
        &:nth-child(2) {
          font-size: 2.85rem;
        }
        &:nth-child(3) {
          margin-top: 0.125rem;
          font-size: 3.275rem;
        }
        &:nth-child(4) {
          font-size: 3.55rem;
        }
        &:nth-child(5) {
          font-size: 3.625rem;
        }
      }
    }
    .heading-duration {
      font-size: 6.85rem;
    }
  }

  // Enter Transitions
  ////////////////////

  $easing-1: cubic-bezier(0.18, 0.89, 0.32, 1.28);
  $initial-delay-1: 200;
  $interval-1: 150;
  $initial-delay-2: 700;
  $interval-2: 100;

  .with-motion & {
    // Initial, hidden state (enter start)

    .logo-line,
    .subtitle {
      opacity: 0;
    }
    .logo-line {
      transform: scale(0.2);
      transition: opacity $duration-very-short + ms ease-in,
        transform $duration-short + ms $easing-1;
    }
    .subtitle {
      transform: translateY(50vh);
      transition: opacity $duration-short + ms ease-in,
        transform $duration-medium + ms $ease-out-expo;
    }
    .logo-line-1 {
      transition-delay: $initial-delay-1 + ms;
    }
    .logo-line-2 {
      transition-delay: $initial-delay-1 + 1 * $interval-2 + ms;
    }
    .subtitle {
      transition-delay: $initial-delay-1 + 2 * $interval-2 + ms;
    }
    .version-number {
      opacity: 0;
      transform: scale(5);
      transition: opacity $duration-short + ms ease-in,
        transform $duration-long + ms cubic-bezier(0.36, 1.18, 0.88, 1.12);
      transition-delay: $initial-delay-1 + 4 * $interval-2 + ms;
    }

    $transition-2: transform $duration-long + ms $ease-out-expo;

    .heading-duration,
    .usp {
      transition: $transition-2;
    }
    .heading-duration {
      transform: translateX(-200%);
    }
    .usp {
      &:nth-child(1) {
        transform: translateX(200%);
        transition-delay: $initial-delay-2 + ms;
      }
      &:nth-child(2) {
        transform: translateX(-200%);
        transition-delay: $initial-delay-2 + 1 * $interval-1 + ms;
      }
      &:nth-child(3) {
        transform: translateX(200%);
        transition-delay: $initial-delay-2 + 2 * $interval-1 + ms;
      }
    }
    .welcome-back {
      opacity: 0;
      transform: translateY(50vh);
      transition: opacity $duration-short + ms ease-in,
        transform $duration-long + ms $ease-out-expo;
      transition-delay: $initial-delay-1 + 4 * $interval-2 + ms;
    }
    @media screen and (min-width: $break-2-cols + px) {
      .usp,
      .cookies-info {
        transition: $transition-2;
      }
      .usp,
      .cookies-info {
        transform: translateX(-200%);
      }
      .usp:nth-child(2) {
        transform: translateX(-200%);
      }
      .cookies-info {
        transition-delay: $initial-delay-2 + 3 * $interval-2 + ms;
      }
      .cookies-cta .button {
        opacity: 0;
        transform: scale(0.2);
        transition: opacity $duration-very-short + ms ease-in,
          transform $duration-medium + ms $easing-1;
        transition-delay: $initial-delay-2 + 8 * $interval-2 + ms;
      }
      .welcome-back {
        transform: translateX(-200%);
      }
    }

    // Ready state (enter end)
    .ready {
      .logo-line,
      .subtitle {
        opacity: 1;
      }
      .logo-line {
        transform: scale(1);
      }
      .subtitle {
        transform: scale(1);
      }
      .version-number {
        opacity: 1;
        transform: scale(1);
      }
      .heading-duration,
      .usp,
      .cookies-info {
        transform: translateX(0);
      }
      .cookies-cta .button {
        opacity: 1;
        transform: scale(1);
      }
      .welcome-back {
        opacity: 1;
        transform: translateX(0) translateY(0);
      }
    }

    // Leave Transitions
    ////////////////////
    .with-leave-transition {
      .splash-leave-active {
        transition: opacity $duration-very-very-long + ms $ease-out-expo;

        .card {
          transition: transform $duration-medium + ms ease-in;
        }
      }

      .splash-leave {
        opacity: 1;

        .card {
          transform: translateY(0px);
        }
      }

      .splash-leave-to {
        opacity: 0;

        .card {
          transform: translateY(-150rem);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheSplash.vue